<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative r5-devices r11-devices-main {{
		sectionclass
	}}"
	style="min-height: 23em"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
		<div class="o-stack__cell">
			<h5 class="title primary-color">
				{{ sectiontitle }}
				<a
					href="javascript:void(0)"
					class="download-icon"
					*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
					(click)="downloadCSV($event)"
					target="_blank"
					><i class="fa fa-download" aria-hidden="true"></i
				></a>
			</h5>
		</div>
	</div>
	<div class="analytics-portlet-content r5-devices r11-devices" *ngIf="hasData">
		<div style="width: 100%; height: 100%">
			<div class="graph-div">
				<div class="wrapper">
					<div class="inline" *ngFor="let item of donutData">
						<app-donut [chartData]="item.seriesData" [chartConfigurationObj]="item.chartConfigurationObj"> </app-donut>
						<div class="center-text">{{ item.percent }}%</div>
						<div class="graph-title">{{ item.title }}</div>
					</div>
				</div>
			</div>
			<div class="legend-area" *ngIf="!legendDisabled">
				<ul class="legend">
					<li
						class="legend_item_dev primary-color-border"
						[ngClass]="{ item_selected: legendItem.selected }"
						(click)="selectLegendItem(legendItem)"
						*ngFor="let legendItem of legend"
					>
						{{ legendItem.displayName }}
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="no-data-container" *ngIf="!hasData">
		<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
			<div class="o-stack__cell">
				<h5 class="title primary-color">{{ sectiontitle }}</h5>
			</div>
		</div>
		<div class="map-no-data c-portlet">No Data to Display</div>
	</div>
</div>
